import React, { Component } from "react";
import { CheckUser, getGeoInfo, logout, userprofileEth } from "../../Model/Users";
import { applyCoupons } from "../../Model/Payment";
import Makepayment from "../Makepayment/Makepayment";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import {
  withRouter,
  SVGIcons,
  ImgIcons,
  VirsionCheck,
  // getDateInfo
} from "../../Helpers/Common";
import { CurrencyData } from "../ExplorePlan/Currency_json";
import { motion } from "framer-motion";
import { EthiopiaCancelSubscription, SubscriptionPlans } from "../../Model/Subscription";
import "../ExplorePlan/ExplorePlan.css";
import { userprofile } from "../../Model/Users";
import BarLoader from "react-spinners/BarLoader";
import Profilemenu from "../Profile_menu/Profilemenu";
import Metadata from "../Metadata/Metadata";

var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Managemembership extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SubscriptionPlansloaded: false,
      SubscriptionPlansData: false,
      showModal: false,
      couponcode: false,
      couponcodeerr: false,
      cplans: false,
      showmakepayment: false,
      userData: false,
      modal: false,
      btntype: false,
      country: "",
      goldenDIcon: "",
      silverDIcon: "",
      msisdn: "",
      product_id: "",
      showconfirm: false,
    };
  }
  makepayment(actualplan, discount, btntext) {
    this.setState({
      showmakepayment: true,
      actualplan: actualplan,
      discount: discount,
      btntype: btntext,
    });
  }
  applyCouponsaction() {
    var postdata = {
      couponcode: this.state.couponcode,
      country: this.state.country,
    };
    applyCoupons(postdata).then((res) => {
      var Resapplycoupon = JSON.parse(res.data);
      if (Resapplycoupon.errorcode == 1008) {
        this.props.navigate("/createaccount");
      } else if (Resapplycoupon.errorcode == 1084) {
        this.setState({ couponcodeerr: Resapplycoupon.message });
      } else if (Resapplycoupon.errorcode == 1007) {
        this.setState({ couponcodeerr: Resapplycoupon.message });
      } else {

        this.setState({
          SubscriptionPlansloaded: true,
          cplans: Resapplycoupon.plans,
        });
        //this.setState({showModal:true,})
      }
    });
  }

  Closemodal() {
    this.setState({ showModal: false });
  }

  handleChange(e) {
    this.setState({ couponcode: e.target.value });
  }
  // backbtn() {
  //   this.setState({ showmakepayment: false })
  // }
  backbtn() {
    this.props.navigate("/profile");
  }
  formatAMPM = (date) => {
    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date(date);
    let name = month[d.getMonth()];
    let day = d.getDate();
    let year = d.getFullYear();

    var ss = name + " " + day + " , " + year;
    return ss;
  };
  componentDidMount() {
    VirsionCheck().then((vcheckres) => {
      if (vcheckres.data) {
        this.setState({
          goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
          silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
        });
      }
    });
    getGeoInfo().then((res) => {
      this.setState({
        country: res,
      });
    });
    //Get Get User checked Check Data
    CheckUser().then((checkuserstatus) => {
      if (checkuserstatus == null) {
        this.props.navigate("/createaccount");
      } else {
        SubscriptionPlans().then((SubscriptionData) => {
          this.setState({
            SubscriptionPlansloaded: true,
            SubscriptionPlansData: SubscriptionData,
            plans: SubscriptionData.data.plans,
          });
        });
        let data = {
          msisdn: localStorage.getItem("msisdn")
        }
        userprofileEth(data).then((res) => {
          this.setState({
            userData: JSON.parse(res.data.message).user_data,
          });
        });
      }
    });
  }
  popupmodal() {
    this.setState({
      modal: true,
    });
  }

  close() {
    this.setState({
      modal: false,
    });
  }

  cancel() {
    this.setState({
      showconfirm: false,
    });
  }

  cancelSubConfirmation() {
    this.setState({
      showconfirm: true,
    })
  }

  cancelSub(msisdn, product_id) {
    EthiopiaCancelSubscription(msisdn, product_id).then((response) => {
      if (response.data.success) {
        localStorage.clear();
        window.localStorage.clear()
        this.props.navigate("/createaccount");
      } else {
        this.setState({
          showconfirm: false,
        })
      }
    }).catch((error) => {
      console.error("Subscription cancel error:", error);
    });
  }

  render() {
    if (this.state.SubscriptionPlansloaded == false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    }

    if (this.state.showconfirm == true) {
      var Unsubscribeconfirm = (
        <div className="logOutpopup" id="logOut">
          <div className="temp52-modal-body">
            <div className="temp52-awesome">
              <h6>Are you sure you want Unsubscibe?</h6>
            </div>

            <button
              type="submit"
              id="sendEnquiryBtn"
              className="btn-white"
              onClick={() => {
                this.cancel();
              }}
            >
              Cancel
            </button>
            <p
              className="temp52-modal-close"
              onClick={() => {
                this.cancelSub(this.state.userData.msisdn, Number(this.state.userData.product_id));
              }}
            >
              Unsubscribe
            </p>
          </div>
        </div>
      );
    }

    if (this.state.userData == false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else if (this.state.showmakepayment == true) {
      return <Makepayment props={this} />;
    } else {
      const settings = {
        centerMode: true,
        variableWidth: false,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 2,
              infinite: true,
              variableWidth: false,
              dots: true,
              cssEase: "linear",
              centerPadding: "70px",
            },
          },
          {
            breakpoint: 820,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 2,
              infinite: true,
              variableWidth: false,
              cssEase: "linear",
              centerPadding: "70px",
              dots: true,
            },
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "70px",
              centerMode: true,
            },
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "55px",
              centerMode: true,
            },
          },
          {
            breakpoint: 416,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "45px",
              centerMode: true,
            },
          },
          {
            breakpoint: 379,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "35px",
              centerMode: true,
            },
          },
          {
            breakpoint: 359,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "30px",
              centerMode: true,
            },
          },
        ],
      };

      return (
        <>
          <Metadata page="BECOME-MEMBER" />
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0 }}
          >
            <main>
              <section className="mb-0 dD-none">
                <header>
                  <div
                    className="mainNav pmenu"
                    onClick={() => {
                      this.backbtn();
                    }}
                  >
                    <div className="docubayBack white">
                      <img src={SVGIcon["back.svg"]} alt="DocuBay Logo" /> My
                      Membership
                    </div>
                  </div>
                </header>
                <div className="temp75">
                  <div className="temp75-inn">
                    <img
                      src={ImageData["billing-bg.png"]}
                      alt="Billing Details"
                      style={{ width: "100%" }}
                      className="tab-manage-member"
                    />
                    <div className="temp75-area">
                      <div className="temp75-left">
                        <img
                          src={this.state.silverDIcon}
                          alt="Billing Details"
                        />
                      </div>
                      <div className="temp75-right">
                        {this.state.userData.subscriptions?.head}
                        <br />
                        <span>{this.state.userData.subscriptions?.title}</span>
                        <img src={ImageData["status-active.png"]} alt="" />
                      </div>
                      <p><div className="Mobile-number-subscription">Mobile Number</div>   {(this.state.userData.msisdn)}</p>

                      <p>
                        Your membership is valid from &nbsp;
                        {this.formatAMPM(this.state.userData.subscription_start_date)}
                        <br />
                        <span></span> to &nbsp;
                        {this.formatAMPM(this.state.userData.subscription_end_date)}
                        <span> </span>
                      </p>
                      {/* <div className="temp75-daysArea">
                        <div className="temp75-days">
                          Ends in{" "}
                          {this.state.userData.subscriptions?.remaining_days}{" "}
                          Days
                        </div>
                      </div> */}
                    </div>
                    <button
                      type="submit"
                      className="cancel-sub"
                      onClick={() => {
                        this.cancelSubConfirmation();
                      }}
                    >
                      Unsubscribe
                    </button>
                  </div>
                </div>
              </section>
            </main>

            {/* desktop section */}
            <main className="setting-main dD-block">
              <section className="mb-0 dD-block">
                <div className="temp75">
                  <div className="temp75-inn">
                    <div className="temp75-img">
                      <img
                        src={ImageData["manage_membership_red.png"]}
                        alt="Billing Details"
                      />
                    </div>
                    <div className="temp75-area">
                      <div className="temp75-headArea">
                        <div className="temp75-left">
                          <img
                            src={this.state.silverDIcon}
                            alt="Billing Details"
                          />
                        </div>
                        <div className="temp75-right">
                          <img src={ImageData["status-active.png"]} alt="" />
                        </div>
                      </div>
                      <p><div className="Mobile-number-subscription">Mobile Number</div>   {(this.state.userData.msisdn)}</p>
                      <p>
                        Your membership is valid from &nbsp;
                        {this.formatAMPM(this.state.userData.subscription_start_date)}
                        <br />
                        <span></span> to &nbsp;
                        {this.formatAMPM(this.state.userData.subscription_end_date)}
                        <span> </span>
                      </p>
                      {/* <div className="temp75-daysArea">
                        <div className="temp75-days">
                          Ends in{" "}
                          {this.state.userData.remaining_days}{" "}
                          Days
                        </div>
                      </div> */}
                    </div>
                    <button
                      type="submit"
                      className="cancel-sub"
                      onClick={() => {
                        this.cancelSubConfirmation();
                      }}
                    >
                      Unsubscribe
                    </button>
                  </div>
                </div>
              </section>
              <Profilemenu
                versioncheck={this.state.VirsionCheckData}
                profile={this.state.userData}
              />
            </main>
            {Unsubscribeconfirm}
            <div className="pb-m"></div>
            {/* <Mobilemenu active="5" /> */}
          </motion.div>
        </>
      );
    }
  }
}

export default withRouter(Managemembership);
